import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Button } from "@/components/ui/button";
import { IMAGES } from "@/data/site";

export function AboutPreview() {
  const points = [
    "Reports reviewed by senior radiologists",
    "Modern, regularly calibrated equipment",
    "Hygienic, comfortable facility",
    "Same-day reporting on most tests",
  ];

  return (
    <section data-testid="about-preview" className="py-20 sm:py-28 bg-white">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal>
          <div className="relative">
            <div className="rounded-3xl overflow-hidden border border-border shadow-xl">
              <img src={IMAGES.aboutCare} alt="Doctor caring for a patient at UNIRAD Diagnostics" className="w-full h-[420px] object-cover" />
            </div>
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="absolute -bottom-6 -right-2 sm:right-6 bg-white rounded-2xl shadow-2xl border border-border p-5 w-44"
            >
              <p className="font-heading text-3xl font-bold text-brand">15+</p>
              <p className="text-sm text-muted-foreground mt-1">Years of trusted diagnostic excellence</p>
            </motion.div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="label-eyebrow">About UNIRAD</p>
          <h2 className="mt-3 font-heading text-3xl lg:text-4xl font-medium tracking-tight text-brand-navy text-balance">
            Trusted Diagnostic Excellence
          </h2>
          <p className="mt-5 text-muted-foreground leading-relaxed">
            UNIRAD DIAGNOSTICS provides reliable diagnostic imaging and pathology services using modern technology and expert medical professionals. Our mission is to deliver accurate, timely, and patient-focused diagnostic care for better healthcare outcomes.
          </p>
          <ul className="mt-6 space-y-3">
            {points.map((p) => (
              <li key={p} className="flex items-center gap-3 text-brand-navy/85">
                <CheckCircle2 className="h-5 w-5 text-brand shrink-0" />
                <span className="text-[15px]">{p}</span>
              </li>
            ))}
          </ul>
          <Link to="/about" className="inline-block mt-8" data-testid="about-learn-more">
            <Button className="rounded-full bg-brand hover:bg-brand-light gap-2 h-11 px-6">
              Learn more about us <ArrowRight className="h-4 w-4" />
            </Button>
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
